import { Fragment } from "react";

function FiInsightCard({ title, children }) {
  return (
    <Fragment>
      <div className="fi-insight-card-container">
        <div className="fi-insight-card-body">
          <div className="fi-insight-card-header">
            <div className="fi-insight-card-icon">
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/insights_blue_menu.svg`}
                alt="Insights Hub"
                className="reset-margin"
                style={{ width: "16px", height: "16px", flexShrink: "0" }}
              />
            </div>
            <h4
              className="reset-margin"
              style={{
                color: "#0587ff",
                fontSize: "16px",
                fontWeight: "400",
                fontStyle: "normal",
                margin: 0,
              }}
            >
              {title}
            </h4>
          </div>

          <div className="fi-insight-card-content">{children}</div>
        </div>
      </div>
    </Fragment>
  );
}

export default FiInsightCard;
